import { render, staticRenderFns } from "./storeItemDetail.vue?vue&type=template&id=150efdc0&scoped=true&"
import script from "./storeItemDetail.vue?vue&type=script&lang=js&"
export * from "./storeItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./storeItemDetail.vue?vue&type=style&index=0&id=150efdc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150efdc0",
  null
  
)

export default component.exports